import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <div className="services">
      <div className="container">
        {/* Hero Section */}
        <section className="services-hero">
          <h1>Our Services</h1>
          <p>Supporting the Oromo community in the UK through traditional Gadaa practices and modern services</p>
        </section>

        {/* Services Grid */}
        <section className="services-content">
          <div className="services-grid">
            
            {/* Cultural Services */}
            <div className="service-category">
              <h2>Cultural Services</h2>
              <div className="service-items">
                <div className="service-item">
                  <h3>Language Classes</h3>
                  <p>Afaan Oromoo (Oromo language) classes for children and adults to preserve our linguistic heritage.</p>
                  <ul>
                    <li>Weekend classes for children (ages 5-16)</li>
                    <li>Adult conversation groups</li>
                    <li>Reading and writing workshops</li>
                    <li>Cultural storytelling sessions</li>
                  </ul>
                </div>
                
                <div className="service-item">
                  <h3>Traditional Arts & Crafts</h3>
                  <p>Workshops and classes to learn traditional Oromo arts, crafts, and cultural practices.</p>
                  <ul>
                    <li>Traditional weaving and textile arts</li>
                    <li>Pottery and craftsmanship</li>
                    <li>Traditional music and dance</li>
                    <li>Cultural artifact preservation</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Community Support Services */}
            <div className="service-category">
              <h2>Community Support</h2>
              <div className="service-items">
                <div className="service-item">
                  <h3>Settlement Support</h3>
                  <p>Helping new arrivals integrate into UK society while maintaining their cultural identity.</p>
                  <ul>
                    <li>Housing assistance and advice</li>
                    <li>Employment guidance and job search support</li>
                    <li>Education system navigation</li>
                    <li>Healthcare system orientation</li>
                  </ul>
                </div>
                
                <div className="service-item">
                  <h3>Legal & Administrative Support</h3>
                  <p>Guidance and support for legal and administrative matters in the UK.</p>
                  <ul>
                    <li>Immigration advice and support</li>
                    <li>Document translation services</li>
                    <li>Benefits and welfare guidance</li>
                    <li>Legal clinic referrals</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Gadaa Practice Services */}
            <div className="service-category">
              <h2>Gadaa Practice Services</h2>
              <div className="service-items">
                <div className="service-item">
                  <h3>Conflict Resolution</h3>
                  <p>Traditional Gadaa-based mediation and conflict resolution services for community disputes.</p>
                  <ul>
                    <li>Family dispute mediation</li>
                    <li>Community conflict resolution</li>
                    <li>Traditional reconciliation ceremonies</li>
                    <li>Restorative justice practices</li>
                  </ul>
                </div>
                
                <div className="service-item">
                  <h3>Community Governance</h3>
                  <p>Democratic decision-making processes based on traditional Gadaa principles.</p>
                  <ul>
                    <li>Community assemblies (Gumii)</li>
                    <li>Democratic elections and leadership rotation</li>
                    <li>Consensus-building workshops</li>
                    <li>Youth leadership development</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Social Services */}
            <div className="service-category">
              <h2>Social Services</h2>
              <div className="service-items">
                <div className="service-item">
                  <h3>Elder Care Support</h3>
                  <p>Respecting and caring for our elders according to Oromo traditions.</p>
                  <ul>
                    <li>Elder companionship programs</li>
                    <li>Traditional medicine knowledge sharing</li>
                    <li>Storytelling and wisdom preservation</li>
                    <li>Healthcare advocacy for elderly</li>
                  </ul>
                </div>
                
                <div className="service-item">
                  <h3>Youth Development</h3>
                  <p>Empowering young Oromo people to succeed while staying connected to their roots.</p>
                  <ul>
                    <li>Mentorship programs</li>
                    <li>Educational scholarships</li>
                    <li>Leadership training</li>
                    <li>Cultural identity workshops</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Ceremonial Services */}
            <div className="service-category">
              <h2>Ceremonial Services</h2>
              <div className="service-items">
                <div className="service-item">
                  <h3>Traditional Ceremonies</h3>
                  <p>Organizing and facilitating traditional Oromo ceremonies and celebrations.</p>
                  <ul>
                    <li>Wedding ceremonies (Fuudha)</li>
                    <li>Naming ceremonies (Maqaa baasuu)</li>
                    <li>Coming of age celebrations</li>
                    <li>Seasonal festivals</li>
                  </ul>
                </div>
                
                <div className="service-item">
                  <h3>Spiritual Guidance</h3>
                  <p>Providing spiritual support based on traditional Oromo beliefs and practices.</p>
                  <ul>
                    <li>Traditional blessing ceremonies</li>
                    <li>Spiritual counseling</li>
                    <li>Prayer and meditation groups</li>
                    <li>Connection with Waaqeffannaa practices</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact for Services */}
        <section className="services-contact">
          <div className="contact-card">
            <h2>Need Our Services?</h2>
            <p>Contact us to learn more about our services or to request assistance. We're here to help our community thrive.</p>
            <div className="contact-info">
              <p><strong>Email:</strong> services@gadaa-uk.org</p>
              <p><strong>Phone:</strong> +44 (0) 20 1234 5678</p>
              <p><strong>Office Hours:</strong> Monday - Friday, 9:00 AM - 5:00 PM</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Services;
